import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class GetSearchUrlDealerUseCase extends UseCase {
  constructor({getUrlSearchService}) {
    super()

    this._getUrlSearchService = getUrlSearchService
  }

  @inlineError
  execute({search, pageName}) {
    return this._getUrlSearchService
      .execute({
        search,
        pageName
      })
      .then(response => response?.toJSON())
      .catch(err => Promise.reject(err))
  }
}
